<template>
  <v-row id="user-management">
    <v-col md="12">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr class="header-row">
            <th class="header-text">ชื่อผู้ใช้งาน</th>
            <th class="header-text">อีเมล</th>
            <th class="header-text">บริษัท</th>
            <th class="header-text">สิทธิการใช้งาน</th>
            <th class="header-text tw-w-40"/>
          </tr>
          </thead>
          <tbody>
          <tr v-for="user in users" :key="user.id" :class="userCompany?.user?.email === user?.user?.email  && 'tw-border-l-4 tw-border-super-light-green tw-text-light-green tw-tracking-tight'">
            <td>
              <div class="tw-flex tw-gap-4 tw-items-center">
                <img 
                v-if="user.user.imageProfileUrl"
                :src="user.user.imageProfileUrl + '=s' + Math.round(30 * getDeviceRatio())"
                class="tw-rounded-full tw-w-8 tw-h-8 tw-object-cover"
              /> 
                <img 
                v-else
                src="/images/icons/prefab-pfp.png"
                class="tw-rounded-full tw-w-8 tw-h-8 tw-object-cover"
              /> 
              <span> {{ user.user.nameFirstTH }} {{ user.user.nameLastTH }} </span>
              </div>
            </td>
            <td >{{ user.user.email }}</td>
            <td class="text-center">{{ user.user.companyName || user.company?.nameEN || "-" }}</td>
            <td class="text-center">{{  getDisplayRole(user, selectedCompanyProductList?.isPdfDoc) }}  </td>
            <td v-if="!userAuth?.isEngineer">
              <edit-user v-if="(userCompany.isAdmin && userCompany?.user?.email !== user?.user?.email) && ( !user?.isDeveloper )" :key="`edit-${user.user.id}`" :product="selectedCompanyProductList" :user="user" :userAuth="userAuth"></edit-user>
              <delete-user v-if="userCompany.isAdmin && userCompany?.user?.email !== user?.user?.email && ( !user?.isDeveloper) && ( !user?.user?.isEngineer )" :key="`delete-${user.user.id}`" :userId="user.id"></delete-user>
            </td>
            <td v-else>
              <edit-user v-if="(userCompany.isAdmin && userCompany?.user?.email !== user?.user?.email)" :key="`edit-${user.user.id}`" :product="selectedCompanyProductList" :user="user" :userAuth="userAuth"></edit-user>
              <delete-user v-if="userCompany.isAdmin && userCompany?.user?.email !== user?.user?.email" :key="`delete-${user.user.id}`" :userId="user.id"></delete-user>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
      <add-user v-if="userCompany.isAdmin" :product="selectedCompanyProductList"></add-user>
    </v-col>
  </v-row>

</template>

<script>
import {mapState} from "vuex";
import AddUser from "./add-user";
import DeleteUser from "./delete-user";
import EditUser from "./edit-user";
import getRole from "@/libs/getRole";

export default {
  name: 'UsersManagement',
  components: {
    AddUser,
    DeleteUser,
    EditUser
  },
  props: {
    userCompany: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      showEmailInput: false
    }
  },
  methods: {
    checkRole: function (user) {
      return getRole(user)
    },

    getDisplayRole(user, isPdfDoc = false) {
      let role = getRole(user)
      switch(role) {
        case 'developer':
          return 'SLD Admin'
        case 'owner':
          return  isPdfDoc ? 'IT Admin' : 'Owner'
        case 'user':
          return 'User'
        default:
          return '-'
      }
    },
    getDeviceRatio() {
      return window.devicePixelRatio
    },
  },
  computed: mapState({
    users: state => state.user.list,
    userAuth: state => state.user.userData,
    selectedCompanyProductList: (state) =>
    state.companies.selectedCompanyProductList,
  }),
  beforeDestroy() {
    this.$store.dispatch('user/getUserListUnsubscribe')
  },
  created() {
    let companyId = this.$route.params.companyId
    if (companyId) {
      this.$store.dispatch('user/getList', {companyId: companyId})
      this.$store.dispatch('user/getRoleUser',{companyId: companyId})
    }
  }
}
</script>
<style lang="scss">
#user-management {
  .header-row {
    background-color: #f0f0f0 !important;
  }

  .v-data-table__wrapper {
    border-radius: 14px;
  }

  .header-text {
    font-size: 16px !important;
    font-weight: bold !important;
    text-align: center !important;
  }
}
</style>
